import type { StatusTone } from "@/shared/components/StatusTag";
import type { NotificationStatus, NotificationType } from "./types";

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
	TASK_ASSIGNED: "Vazifa biriktirildi",
	TASK_OVERDUE: "Muddati o'tdi",
	EQUIPMENT_OFFLINE: "Texnika oflayn",
	STAFF_OFFLINE: "Xodim oflayn",
	ATTENDANCE_OUTSIDE_TERRITORY: "Hudud tashqarisida davomat",
};

export const NOTIFICATION_TYPE_OPTIONS: { value: NotificationType; label: string }[] = (
	Object.entries(NOTIFICATION_TYPE_LABELS) as [NotificationType, string][]
).map(([value, label]) => ({ value, label }));

export const NOTIFICATION_TYPE_COLORS: Record<NotificationType, string> = {
	TASK_ASSIGNED: "blue",
	TASK_OVERDUE: "red",
	EQUIPMENT_OFFLINE: "orange",
	STAFF_OFFLINE: "gold",
	ATTENDANCE_OUTSIDE_TERRITORY: "purple",
};

export const NOTIFICATION_STATUS_LABELS: Record<NotificationStatus, string> = {
	SENT: "Yuborildi",
	SKIPPED: "O'tkazib yuborildi",
	FAILED: "Xatolik",
};

export const NOTIFICATION_STATUS_TONES: Record<NotificationStatus, StatusTone> = {
	SENT: "success",
	SKIPPED: "default",
	FAILED: "error",
};

/** relatedEntityType → Uzbek label for the related entity column */
export const RELATED_ENTITY_LABELS: Record<string, string> = {
	task: "Topshiriq",
	equipment: "Texnika",
	staff: "Xodim",
	attendance: "Davomat",
};
